import { useState } from 'react';
import { ReviewItem as ReviewProps } from '@silvertours/common-landingpages-view';

import { ExpandedReviewItem } from './ExpandedReviewItem';
import { LargeReviewItem } from './LargeReviewItem';
import { SummaryReviewItem } from './SummaryReviewItem';
import { ReviewListContainer } from './Reviews.styles';

type ReviewListProps = {
  items: Array<ReviewProps>;
  largeReviews?: boolean;
  locationName?: string;
};

const ReviewList = (props: ReviewListProps) => {
  const { largeReviews, locationName, items } = props;
  const [selectedItem, setSelectedItem] = useState<ReviewProps | null>();
  const Item = largeReviews ? LargeReviewItem : SummaryReviewItem;

  return (
    <ReviewListContainer>
      {selectedItem ? (
        <ExpandedReviewItem
          {...selectedItem}
          locationName={locationName}
          onClose={() => setSelectedItem(null)}
        />
      ) : (
        <ul>
          {items.map(item => (
            <Item
              {...item}
              locationName={locationName}
              element="li"
              key={item.reviewerName}
              onClick={() => setSelectedItem(item)}
            />
          ))}
        </ul>
      )}
    </ReviewListContainer>
  );
};

export { ReviewList };
